import {
  isIndividualPoolSitePath,
  isShortPoolMonitoringPath,
} from '../components/monitoring/cctvPopupRoutes';

export const POOL_MANAGEMENT_TAB_MONITORING = 7;

export type PoolSiteView = 'management' | 'monitoring';

export type PoolSiteLocationState = {
  poolSiteView?: PoolSiteView;
  /** @deprecated poolSiteView 사용 */
  poolManagementTab?: number;
};

export function isPoolSiteStandaloneView(
  pathname: string,
  isAdminLoggedIn: boolean,
): boolean {
  return isIndividualPoolSitePath(pathname) && !isAdminLoggedIn;
}

export function poolSiteShortPath(poolCode: string): string {
  return `/${encodeURIComponent(poolCode)}`;
}

export function poolManagementPath(poolCode: string, siteStandalone: boolean): string {
  const code = encodeURIComponent(poolCode);
  return siteStandalone ? poolSiteShortPath(poolCode) : `/pool-management/${code}`;
}

/** 관리자용 전체 경로. 현장은 poolSiteShortPath + state.poolSiteView */
export function poolMonitoringPath(poolCode: string, siteStandalone: boolean): string {
  if (siteStandalone) {
    return poolSiteShortPath(poolCode);
  }
  return `/pool-monitoring/${encodeURIComponent(poolCode)}`;
}

export function poolSiteMonitoringState(): PoolSiteLocationState {
  return { poolSiteView: 'monitoring' };
}

export function readPoolSiteView(state: unknown): PoolSiteView {
  if (state && typeof state === 'object') {
    const s = state as PoolSiteLocationState;
    if (s.poolSiteView === 'monitoring' || s.poolSiteView === 'management') {
      return s.poolSiteView;
    }
    if (s.poolManagementTab === POOL_MANAGEMENT_TAB_MONITORING) {
      return 'monitoring';
    }
  }
  return 'management';
}

export function isLegacyPoolMonitoringPath(pathname: string): boolean {
  return /^\/pool-monitoring\/[^/]+/.test(pathname);
}

export function shouldRedirectStandaloneMonitoringToPoolEntry(
  pathname: string,
  siteStandalone: boolean,
): boolean {
  if (!siteStandalone) return false;
  return isLegacyPoolMonitoringPath(pathname) || isShortPoolMonitoringPath(pathname);
}
